import './App.css';
import { BrowserRouter as Router, Route } from "react-router-dom";
//Component
import { Login } from "./module/login";
import { Manual } from "./module/manual";
import { FAQ } from "./module/faq";
import { ProtectedRoutes } from "./template/ProtectedRoutes";
import Sand from "./module/sandbox";
import HandlePaperTicket from './module/paperticket/paperticket';
function App() {
    return (
        <>
            <Router  >
                <Route exact path="/Login" component={Login} />
                <Route exact path="/Sandbox" component={Sand} />
                <Route exact path="/register" component={HandlePaperTicket} />
                {/* <Route exact path="/Manual" component={Manual} /> */}
                {/* <RouteLayout exact path="/" component={Portal} /> */}
                <Route exact path={ProtectedRoutes.route} component={ProtectedRoutes} />
            </Router>
        </>
    );
}

export default App;
